import axios from '../../_utils/axios';

// ----------------------------------------------------------------------

const deleteSpecimens = async (channelId) => {
  return await axios.delete(`specimens/${channelId}`)
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default deleteSpecimens;